import DurationPicker from './DurationPicker'

export default DurationPicker
// eslint-disable-next-line import/export
export * from './DurationPicker'
